import React from 'react';
import PropTypes from 'prop-types';
import { Image as DefaultIcon } from 'react-feather';
import './icon.scss';
import clsx from 'clsx';
import { IconColors, IconSizes } from './icon-dictionary';

const IconWrapper = React.forwardRef(({
  icon, size, color, className, strokeWidth, tabIndex, onClick, disabled,
}, ref) => {
  const classNames = clsx('icon-wrapper-cont', color, { disabled }, size, className);
  const LibIcon = icon === null ? DefaultIcon : icon;

  const handleOnClick = () => {
    if (disabled) {
      return;
    }
    if (onClick && typeof onClick === 'function') {
      onClick.call(null);
    }
  };

  return (
    <LibIcon
      onClick={handleOnClick}
      ref={ref}
      className={classNames}
      strokeWidth={strokeWidth}
      tabIndex={tabIndex}
    />
  );
});

IconWrapper.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element,
    PropTypes.elementType, PropTypes.func, PropTypes.oneOf([null])]),
  size: PropTypes.string,
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  tabIndex: PropTypes.number,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,

};

IconWrapper.defaultProps = {
  icon: null,
  size: IconSizes.LARGE,
  color: IconColors.GREY,
  strokeWidth: 2,
  className: '',
  tabIndex: -1,
  onClick: null,
  disabled: false,
};

export {
  IconWrapper as default,
  IconColors,
  IconSizes,
};
